import _ from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { contacts } from '../../../../modules/customer/profile';
import ContactListItem from './ContactListItem';
import { BoxesRow, Box } from '../../profilePage/components';
import LoadingPanel from '../../../components/LoadingPanel';

const ContactList = ({ contactsList, isLoading }) => <div className="contact-list">
    {isLoading && <LoadingPanel />}
    {!isLoading && contactsList && contactsList.map((contact, index) => 
        <ContactListItem contact={contact} comment={contact.comment !== "" ? contact.comment : contact.actionTaken} index={index} />
    )}
    {!isLoading && contactsList.length === 0 && <div className="alert alert-warning">Ingen kontakter</div>}
    </div>


const mapStateToProps = createStructuredSelector({
    contactsList: contacts.selectors.getContacts,
    isLoading: contacts.selectors.isLoading
});

export default connect(mapStateToProps)(ContactList)